
import { Component, Vue, Ref } from 'vue-property-decorator'
import { registerNiceModalComponent } from '@xt/client/utils/messageModalQueue/index'
import type {
  ModalQueueItem,
  TopicTipProps,
  GiftProps,
  CouponProps,
  IMessageResp,
  ConfirmModalResult
} from '@xt/client/utils/messageModalQueue/types.d.ts'
import { ModalQueueItemType, EnumRegisterModalNames, ModalQueueItemCode } from '@xt/client/enums/messageModalQueue/index'
import { Observer } from 'mobx-vue'
import type { BaseCouponItem } from '@xt/client/types/coupon'

registerNiceModalComponent()

@Observer
@Component({
  components: {}
})
export default class MessageModalQueue extends Vue {
  modalQueue: Array<ModalQueueItem> = []
  consumerStarted: boolean = false

  tansformQueueItem(data: IMessageResp): ModalQueueItem | null {
    switch (data.noticeSubType) {
      case ModalQueueItemCode.Recruit:
      case ModalQueueItemCode.Init:
        const type = data.noticeSubType === ModalQueueItemCode.Init ? ModalQueueItemType.Init : ModalQueueItemType.Recruit
        return this.transformTopicTipProps(data, type)
      case ModalQueueItemCode.Gift:
        return this.transformGiftProps(data)
      case ModalQueueItemCode.Coupon:
        return this.transformCouponProps(data)
      default:
        return null
    }
  }

  transformCouponProps(data: IMessageResp): CouponProps {
    return {
      successList: data.bizData!.jsonContent! as unknown as Array<BaseCouponItem>,
      failList: [],
      type: ModalQueueItemType.Coupon
    }
  }

  transformGiftProps(data: any): GiftProps {
    return {
      ...data,
      type: ModalQueueItemType.Gift
    }
  }

  transformTopicTipProps(data: IMessageResp, type: ModalQueueItemType): TopicTipProps {
    const parsed = JSON.parse(data.bizData!.jsonContent!) as { regionName: string; guildName: string }

    return {
      title: `${parsed.regionName}分桐`,
      subTitle: type === ModalQueueItemType.Init ? '成功开启啦~' : '助力成功',
      description: type === ModalQueueItemType.Init ? `恭喜${parsed.regionName}桐好，今后笔墨相伴，常赴雅约` : '分桐负责人招募开启',
      bizId: data.bizId,
      backgroundUrl: `${this.$store.$global.static}/images/topic/pc/${type}-pop-bg.png`,
      layoutClassName: type ? `${type}-confirm-modal` : 'congratulate-confirm-modal',
      type
    }
  }

  /** 拉取消息生成弹窗队列 */
  async checkShowCongratulateModal() {
    if (!this.$store.$storeUser.UserInfo.id) return

    const res = await this.$store.$storeUser.messageNotice.onLoadPop()

    if (!res.length) return

    res.forEach(item => {
      let queueItem: ModalQueueItem | null = null

      queueItem = this.tansformQueueItem(item)

      if (queueItem) this.modalQueue.push(queueItem)
    })
  }

  private async startConsumer() {
    try {
      if (this.consumerStarted) return

      this.consumerStarted = true

      for (const item of this.modalQueue) {
        if (item.type === ModalQueueItemType.Init || item.type === ModalQueueItemType.Recruit) {
          const res: ConfirmModalResult = await this.$niceModal.show(EnumRegisterModalNames.Topic, item)
          if (res.status === 'ok') {
            console.log('consumeModalQueue success', res)
          }
        } else if (item.type === ModalQueueItemType.Gift) {
          await this.$niceModal.show(EnumRegisterModalNames.Gift, {
            dataSource: item
          })
        } else if (item.type === ModalQueueItemType.Coupon) {
          await this.$niceModal.show(EnumRegisterModalNames.Coupon, {
            data: item
          })
        }

        await this.$sleep(100) // 可选短延迟以避免 UI 闪烁
      }
    } catch (err) {
      console.error('consumer unexpected error', err)
    }
  }

  async created(): Promise<void> {
    await this.checkShowCongratulateModal()
    this.startConsumer()
  }

  destroyed(): void {}
}
